import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { CampaignsLive } from './pages/CampaignsLive'
import { CareLive } from './pages/CareLive'
import { DashboardLive } from './pages/DashboardLive'
import { FieldActivateLive } from './pages/FieldActivateLive'
import { PlotMonitorLive } from './pages/PlotMonitorLive'
import { TagsLive } from './pages/TagsLive'
import { TreePassportLive } from './pages/TreePassportLive'
import { VerificationLive } from './pages/VerificationLive'

function StaffLayout() { return <AppShell><Outlet /></AppShell> }

export default function AppLive() {
  return <Routes>
    <Route path="/t/:code" element={<TreePassportLive />} />
    <Route element={<StaffLayout />}>
      <Route path="/dashboard" element={<DashboardLive />} />
      <Route path="/campaigns" element={<CampaignsLive />} />
      <Route path="/field/activate" element={<FieldActivateLive />} />
      <Route path="/field/plots" element={<PlotMonitorLive />} />
      <Route path="/verification" element={<VerificationLive />} />
      <Route path="/care" element={<CareLive />} />
      <Route path="/tags" element={<TagsLive />} />
    </Route>
    <Route path="/" element={<Navigate replace to="/dashboard" />} />
    <Route path="*" element={<Navigate replace to="/dashboard" />} />
  </Routes>
}
